import { FunctionComponent, ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export type Props = {
  target: string;
};

const Redirector: FunctionComponent<Props> = (props) => {
  const history = useNavigate();

  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  useEffect(() => {
    history(props.target);
  }, [history, props.target]);
  return <>redirecting</>;
};

export default Redirector;
